export type ServiceQueueRequestMessages = {
  deleteServiceQueueSuccess: string;
  createServiceQueueSuccess: string;
  updateServiceQueueSuccess: string;

  deleteServiceQueueError: string;
  createServiceQueueError: string;
  updateServiceQueueError: string;
  serviceQueueNotFoundError: string;
  serviceQueueNotFoundDescription: string;
  serviceQueueNotFoundAlt: string;
  serviceQueueErrorToLoad: string;
};

export const SERVICE_QUEUE_REQUEST_MESSAGES: ServiceQueueRequestMessages = {
  deleteServiceQueueSuccess: "Fila de atendimento deletada com sucesso.",
  createServiceQueueSuccess: "Fila de atendimento criada com sucesso.",
  updateServiceQueueSuccess: "Fila de atendimento editada com sucesso.",

  deleteServiceQueueError: "Erro ao deletar fila de atendimento.",
  createServiceQueueError: "Erro ao criar fila de atendimento.",
  updateServiceQueueError: "Erro ao editar fila de atendimento.",
  serviceQueueNotFoundError: "Filas de atendimento não encontradas.",
  serviceQueueNotFoundDescription:
    "Não conseguimos encontrar nenhuma fila de atendimento, recarregue a página e tente novamente.",
  serviceQueueNotFoundAlt: "Imagem indicando erro ao buscar filas de atendimento.",
  serviceQueueErrorToLoad: "Erro ao buscar filas de atendimento.",
};
